export default {
      id: "形状结合(1)-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "img/icons.a5c507dd.svg#形状结合(1)",
      toString: function () {
        return this.url;
      }
    }